import React from 'react';

const teamData = [
  {
    name: 'Mike Hardson',
    role: 'Consultant',
    image: '/assets/images/resource/team-1.jpg',
    delay: '',
  },
  {
    name: 'Jessica Brown',
    role: 'Consultant',
    image: '/assets/images/resource/team-2.jpg',
    delay: '400ms',
  },
  {
    name: 'David Cooper',
    role: 'Consultant',
    image: '/assets/images/resource/team-3.jpg',
    delay: '800ms',
  },
  {
    name: 'Christine Eve',
    role: 'Consultant',
    image: '/assets/images/resource/team-4.jpg',
    delay: '1200ms',
  },
];

const TeamSection = () => {
  return (
    <section className="team-section">
      <div className="anim-icons">
        <span className="icon icon-object-1"></span>
      </div>
      <div className="auto-container">
        <div className="sec-title text-center">
          <span className="sub-title">Professional people</span>
          <h2>
            Meet Our Expert Visa <br /> Consultants.
          </h2>
        </div>
        <div className="row">
          {teamData.map((member, index) => (
            <div
              className="team-block col-xl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInUp"
              data-wow-delay={member.delay}
              key={index}
            >
              <div className="inner-box">
                <div className="image-box">
                  <figure className="image">
                    <a href="page-team-details.html">
                      <img src={member.image} alt={member.name} />
                    </a>
                  </figure>
                  <span className="share-icon fa fa-share-alt"></span>
                  <div className="social-links">
                    <a href="#"><i className="fab fa-twitter"></i></a>
                    <a href="#"><i className="fab fa-facebook"></i></a>
                    <a href="#"><i className="fab fa-pinterest-p"></i></a>
                  </div>
                </div>
                <div className="info-box">
                  <h4 className="name">
                    <a href="page-team-details.html">{member.name}</a>
                  </h4>
                  <span className="designation">{member.role}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamSection;